import React from 'react';

import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import PageHeader from '@/components/Layout/PageHeader';
import FAQ from '@/components/Pages/Help/FAQ';
import Button from '@/components/UI/Buttons/Button';
import CloseButton from '@/components/UI/Buttons/CloseButton';
import { LineChatIcon } from '@/components/UI/Icons/LineChatIcon';
import { openZendesk } from '@/components/Zendesk';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { selectIsThailand } from '@/store/selectors/commonSelectors';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

function HelpDrawer({ closeDrawer }: { closeDrawer: () => void }) {
  const isThailand = useSelector(selectIsThailand);
  const intl = useIntl();
  const { openModal } = useModal();

  const handleOpenZendesk = () => {
    openZendesk();
    closeDrawer();
    triggerGTag(GTagEvents.open_support);
  };

  const handleOpenLineChat = () => {
    closeDrawer();
    openModal(MODALS.LINE_CHAT);
  };

  return (
    <div
      className="flex flex-col items-end z-[2] relative"
      role="presentation"
      aria-label="Help Drawer"
    >
      <div className="max-w-[520px] bg-offWhite relative">
        <PageHeader>
          <h1>{intl.formatMessage({ id: 'help.header' })}</h1>
          <p>{intl.formatMessage({ id: 'help.subHeader' })}</p>
          <div className="flex items-center justify-center gap-4 [&>button]:!mx-0">
            {/*@ts-ignore*/}
            <Button light iconleft onClick={handleOpenZendesk}>
              <ChatBubbleLeftRightIcon /> {intl.formatMessage({ id: 'help.contactButton' })}
            </Button>
            {isThailand && (
              //@ts-ignore - Button needs refactor - Out of scope for now
              <Button
                light
                iconleft
                onClick={handleOpenLineChat}
                className="flex items-center gap-2"
              >
                <LineChatIcon />
                <span>{intl.formatMessage({ id: 'help.lineChatButton' })}</span>
              </Button>
            )}
          </div>
        </PageHeader>
        <FAQ />
        <CloseButton light left onClick={closeDrawer} />
      </div>
    </div>
  );
}

HelpDrawer.propTypes = {
  closeDrawer: PropTypes.func.isRequired,
};

export default HelpDrawer;
